import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import {registerIcons} from './app/providers/fontawesome.provider';
import {runInInjectionContext} from '@angular/core';
import { addIcons } from 'ionicons';
import * as ionicons from 'ionicons/icons';
bootstrapApplication(AppComponent, appConfig)
    .then(appRef => {
        // Esegui registerIcons in un contesto d'iniezione:
        runInInjectionContext(appRef.injector, () => {
            registerIcons();
            addIcons(ionicons);
        });
    })
    .catch(err => console.error(err));
